/* styled.tsx generated by @compiled/babel-plugin v0.24.0 */
import _extends from "@babel/runtime/helpers/extends";
import "./styled.compiled.css";
import { forwardRef } from 'react';
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { N0, N60A } from '@atlaskit/theme/colors';
export const OptInBackgroundBorder = forwardRef(({
  as: C = "div",
  style: __cmpls,
  ...__cmplp
}, __cmplr) => {
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: {
      ...__cmpls,
      "--_1vcp0mh": ix(__cmplp.width, "px")
    },
    ref: __cmplr,
    className: ax(["_1reo15vq _18m915vq _16qsreen _2rko14y2 _1yt4v77o _kqswh2mm _11q7z742", __cmplp.width ? "_1bsb1efm" : "_1bsbkbql", __cmplp.className])
  }));
});
if (process.env.NODE_ENV !== 'production') {
  OptInBackgroundBorder.displayName = 'OptInBackgroundBorder';
}
export const OptInContainer = forwardRef(({
  as: C = "div",
  style: __cmpls,
  ...__cmplp
}, __cmplr) => {
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_2rko1l7b _1e0c1txw _2lx21bp4 _bfhk1bhr", __cmplp.className])
  }));
});
if (process.env.NODE_ENV !== 'production') {
  OptInContainer.displayName = 'OptInContainer';
}
export const ImageWrapper = forwardRef(({
  as: C = "div",
  style: __cmpls,
  ...__cmplp
}, __cmplr) => {
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_2rko1k7a _1e0c1txw _1jpx1dfr _mezj1osq _1biu1k7a", __cmplp.className])
  }));
});
if (process.env.NODE_ENV !== 'production') {
  ImageWrapper.displayName = 'ImageWrapper';
}
export const ContentContainer = forwardRef(({
  as: C = "div",
  style: __cmpls,
  ...__cmplp
}, __cmplr) => {
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1txw _1yt41ejb _2lx21bp4 _1wpz1fhb _zulpu2gc _4cvr1y6m", __cmplp.className])
  }));
});
if (process.env.NODE_ENV !== 'production') {
  ContentContainer.displayName = 'ContentContainer';
}
export const HeaderWrapper = forwardRef(({
  as: C = "div",
  style: __cmpls,
  ...__cmplp
}, __cmplr) => {
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_k48pni7l _1wyb7vkz _vwz4gktf", __cmplp.className])
  }));
});
if (process.env.NODE_ENV !== 'production') {
  HeaderWrapper.displayName = 'HeaderWrapper';
}
export const BodyWrapper = forwardRef(({
  as: C = "div",
  style: __cmpls,
  ...__cmplp
}, __cmplr) => {
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wybdlk8 _vwz4gktf", __cmplp.className])
  }));
});
if (process.env.NODE_ENV !== 'production') {
  BodyWrapper.displayName = 'BodyWrapper';
}
export const LearnMoreWrapper = forwardRef(({
  as: C = "span",
  style: __cmpls,
  ...__cmplp
}, __cmplr) => {
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_k48p1nn1", __cmplp.className])
  }));
});
if (process.env.NODE_ENV !== 'production') {
  LearnMoreWrapper.displayName = 'LearnMoreWrapper';
}
export const ButtonContainer = forwardRef(({
  as: C = "div",
  style: __cmpls,
  ...__cmplp
}, __cmplr) => {
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1txw _1bsb1osq _19pku2gc _1bahesu3 _zulp1b66", __cmplp.className])
  }));
});
if (process.env.NODE_ENV !== 'production') {
  ButtonContainer.displayName = 'ButtonContainer';
}
export const OrgAdminDefaultBodyWrapper = forwardRef(({
  as: C = "div",
  style: __cmpls,
  ...__cmplp
}, __cmplr) => {
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_19pku2gc", __cmplp.className])
  }));
});
if (process.env.NODE_ENV !== 'production') {
  OrgAdminDefaultBodyWrapper.displayName = 'OrgAdminDefaultBodyWrapper';
}